module.exports = __webpack_public_path__ + "static/img/banner.df15f32.webp";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/home/download/banner.webp
// module id = Ss7/
// module chunks = 3